import { OLD_MOBILE_BREAKPOINT_MAX } from '../consts';

const isDesktop = () => window.innerWidth > OLD_MOBILE_BREAKPOINT_MAX;
export default isDesktop;
